import React from 'react';
import Modal from '~/components/ModalNewVehicle';
import { ContainerModal, TitleModal, Divider } from '../../../MapOpportunities/styles';
import InfoPanel from '../../../MapOpportunities/components/MapModalSections/InfoPanel';
import NameValueItem from '../../../MapOpportunities/components/MapModalSections/NameValueItem';
import { HinovaVeiculo } from '~/types';

interface VehicleDetailsProps {
  vehicle: HinovaVeiculo;
  open: boolean;
  onClose: () => void;
}

const VehicleDetails: React.FC<VehicleDetailsProps> = ({ vehicle, open, onClose }) => {
  return (
    <Modal onConfirm={onClose} onCancel={onClose} open={open} question={false} buttonPositive='Fechar'>
      <ContainerModal>
        <TitleModal>Detalhes do Veículo</TitleModal>
        <Divider height={15} />

        <InfoPanel title='Informações Básicas'>
          <NameValueItem title='Placa'>{vehicle.placa || 'N/A'}</NameValueItem>
          <NameValueItem title='Modelo'>{vehicle.modelo || 'N/A'}</NameValueItem>
          <NameValueItem title='Marca'>{vehicle.marca || 'N/A'}</NameValueItem>
          <NameValueItem title='Ano'>{vehicle.ano || 'N/A'}</NameValueItem>
          <NameValueItem title='Cor'>{vehicle.cor || 'N/A'}</NameValueItem>
          <NameValueItem title='Valor FIPE'>
            {vehicle.valor_fipe ? `R$ ${vehicle.valor_fipe.toFixed(2)}` : 'N/A'}
          </NameValueItem>
          <NameValueItem title='Cilindrada'>{vehicle.cilindrada || 'N/A'}</NameValueItem>
          <NameValueItem title='Tipo de Veículo'>{vehicle.tipo_veiculo || 'N/A'}</NameValueItem>
        </InfoPanel>

        <InfoPanel title='Identificação'>
          <NameValueItem title='Chassi'>{vehicle.chassi || 'N/A'}</NameValueItem>
          <NameValueItem title='RENAVAM'>{vehicle.renavam || 'N/A'}</NameValueItem>
          <NameValueItem title='CPF Associado'>{vehicle.associado_cpf || 'N/A'}</NameValueItem>
        </InfoPanel>
      </ContainerModal>
    </Modal>
  );
};

export default VehicleDetails;
